var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('Breadcrumb',{attrs:{"pgTitle":_vm.$t('nav.logs'),"pgIcon":'bx bx-brush-alt',"refs":_vm.refs,"addNew":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }